<div class="icon-text-container">
  <div class="icon">
    <img ngSrc="assets/images/icon-{{icon}}.svg" width="24" height="24" alt="{{icon}}">
  </div>
  <div class="text">
    <span *ngIf="textBold" class="semiBold" [innerHTML]="textBold"></span><br *ngIf="textBold && text">
    <span *ngIf="text" [innerHTML]="text"></span>
  </div>
</div>
